import { useEffect, useState } from "react";
import { Camera } from "lucide-react";
import { fetchAuthImage } from "../../lib/metalApi";

export const AuthImage = ({ src, className = "", alt = "", onZoom, testId }) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    let obj = null;
    fetchAuthImage(src)
      .then((u) => {
        if (!alive) return;
        obj = u;
        setUrl(u);
      })
      .catch(() => alive && setFailed(true));
    return () => {
      alive = false;
      if (obj) URL.revokeObjectURL(obj);
    };
  }, [src]);

  if (failed) {
    return (
      <div className={`flex items-center justify-center bg-[#17122E] ${className}`}>
        <Camera className="h-5 w-5 text-[#8B87A8]" />
      </div>
    );
  }
  if (!url) return <div className={`animate-pulse bg-[#17122E] ${className}`} />;
  return (
    <img
      src={url}
      className={`${className} ${onZoom ? "cursor-zoom-in" : ""}`}
      alt={alt}
      data-testid={testId}
      onClick={onZoom ? () => onZoom(url) : undefined}
    />
  );
};
